import type { Property, Entity } from '@cognitoforms/model.js';
import { PropertyConverter } from '@cognitoforms/model.js';

export default class SignatureSignedAtConverter extends PropertyConverter {
	shouldConvert(context: Entity, prop: Property): boolean {
		return prop.containingType.fullName === 'Signature' && prop.name === 'SignedAt';
	}

	serialize(context: Entity, value: any, prop: Property) {
		return { key: prop.name, value: value instanceof Date ? value.toISOString() : value };
	}

	deserialize(context: Entity, value: any) {
		return typeof value === 'string' ? new Date(value) : value;
	}
}
